import axios from "axios";
import { toast } from "sonner";

/**
 * Item 4 (June 2026): admin JWTs expire after 72h. Uploads and other admin
 * actions used to surface a raw "Invalid token" error with no way forward.
 *
 * IMPORTANT (June 2026 hotfix): this must ONLY react to a genuinely expired
 * token. The backend also returns 401 "Invalid token" / "Invalid token type"
 * when a valid session hits an endpoint built for the *other* identity type —
 * treating those as an expiry logged every SSO admin straight back out. So we
 * match the one detail that can only come from jwt.ExpiredSignatureError.
 */
const EXPIRY_DETAILS = ["token expired"];
const SKIP_PATHS = ["/auth/me", "/auth/levelup", "/auth/levelup-sso", "/admin/login", "/auth/login"];

let redirecting = false;

export function installAuthInterceptor() {
  axios.interceptors.response.use(
    (res) => res,
    (error) => {
      const status = error?.response?.status;
      const url = error?.config?.url || "";
      const detail = String(error?.response?.data?.detail || "").trim().toLowerCase();

      const isExpired = status === 401 && EXPIRY_DETAILS.includes(detail);
      const path = url.split("?")[0];
      const onSkippedPath = SKIP_PATHS.some((p) => path.endsWith(p));
      const hasSession = !!(localStorage.getItem("admin_token") || localStorage.getItem("app_token"));

      if (isExpired && !onSkippedPath && hasSession && !redirecting) {
        redirecting = true;
        ["admin_token", "admin_name", "admin_role", "admin_permissions", "app_token"].forEach((k) =>
          localStorage.removeItem(k)
        );
        sessionStorage.setItem("session_expired", "1");
        toast.error("Your session expired — please sign in again.");
        setTimeout(() => {
          window.location.assign("/login");
        }, 1400);
      }
      return Promise.reject(error);
    }
  );
}
